import { render, staticRenderFns } from "./NoProductPage.vue?vue&type=template&id=4440148c&scoped=true&"
import script from "./NoProductPage.vue?vue&type=script&lang=js&"
export * from "./NoProductPage.vue?vue&type=script&lang=js&"
import style0 from "./NoProductPage.vue?vue&type=style&index=0&id=4440148c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4440148c",
  null
  
)

export default component.exports